import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ARCanvas from "./components/ARCanvas";
import AddProduct from "./components/AddProduct";
import OrderConfirmation from "./components/OrderConfirmation";
import { UserProvider } from "./contexts/userState";
import "bootstrap/dist/css/bootstrap.min.css";
import "@mui/material/styles";
import MeasurementConfirmationPage from "./components/MeasurementConfirmationPage";
import GuidePdfPage from "./components/GuidePdfPage";

function App() {
  return (
    <UserProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<ARCanvas />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
             <Route path="/measurement-confirmation" element={<MeasurementConfirmationPage />} />
              <Route path="/guide-pdf" element={<GuidePdfPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;
